export type RelationshipType = 'serious' | 'casual_fixed' | 'casual_flex';

export type ScreenVariant = 'daddy_hetero' | 'daddy_other' | 'baby_female_hetero_bi' | 'baby_other';

export interface RelationshipOption {
  id: RelationshipType;
  label: string;
  highlight: string;
  description: string;
  chips: string[];
  emoji: string;
  accentColor: 'rose' | 'pink' | 'amber';
}

export interface RelationshipScreenConfig {
  title: string;
  subtitle: string;
  options: RelationshipOption[];
}

// Screen configurations per audience variant
export const RELATIONSHIP_INTENT_SCREENS: Record<ScreenVariant, RelationshipScreenConfig> = {
  daddy_hetero: {
    title: "O que você busca?",
    subtitle: "Escolha o tipo de conexão ideal para você",
    options: [
      {
        id: 'serious',
        label: 'Relacionamento Sério',
        highlight: 'Exclusivo e duradouro',
        description: 'Busco uma parceira para construir algo especial. Compromisso, exclusividade e futuro juntos.',
        chips: ['Exclusividade', 'Compromisso', 'Futuro juntos'],
        emoji: '💍',
        accentColor: 'rose'
      },
      {
        id: 'casual_fixed',
        label: 'Caso Fixo',
        highlight: 'Recorrente, sem compromisso',
        description: 'Encontros regulares com a mesma pessoa. Conexão e prazer sem a pressão de um relacionamento formal.',
        chips: ['Encontros regulares', 'Mesma pessoa', 'Sem formalidades'],
        emoji: '💕',
        accentColor: 'pink'
      },
      {
        id: 'casual_flex',
        label: 'Encontros',
        highlight: 'Experiências pontuais',
        description: 'Momentos especiais quando a química acontece. Sem expectativas de continuidade, apenas o prazer do agora.',
        chips: ['Sem compromisso', 'Flexibilidade total', 'Experiências únicas'],
        emoji: '🍸',
        accentColor: 'amber'
      }
    ]
  },
  daddy_other: {
    title: "O que você busca?",
    subtitle: "Escolha o tipo de conexão ideal para você",
    options: [
      {
        id: 'serious',
        label: 'Relacionamento Sério',
        highlight: 'Exclusivo e duradouro',
        description: 'Busco alguém para construir algo especial. Compromisso, exclusividade e futuro juntos.',
        chips: ['Exclusividade', 'Compromisso', 'Futuro juntos'],
        emoji: '💍',
        accentColor: 'rose'
      },
      {
        id: 'casual_fixed',
        label: 'Caso Fixo',
        highlight: 'Recorrente, sem compromisso',
        description: 'Encontros regulares com a mesma pessoa. Conexão e prazer sem a pressão de um relacionamento formal.',
        chips: ['Encontros regulares', 'Mesma pessoa', 'Sem formalidades'],
        emoji: '💕',
        accentColor: 'pink'
      },
      {
        id: 'casual_flex',
        label: 'Encontros',
        highlight: 'Experiências pontuais',
        description: 'Momentos especiais quando a química acontece. Sem expectativas de continuidade, apenas o prazer do agora.',
        chips: ['Sem compromisso', 'Flexibilidade total', 'Experiências únicas'],
        emoji: '🍸',
        accentColor: 'amber'
      }
    ]
  },
  baby_female_hetero_bi: {
    title: "O que você busca?",
    subtitle: "Escolha o tipo de conexão ideal para você",
    options: [
      {
        id: 'serious',
        label: 'Relacionamento Sério',
        highlight: 'Exclusivo e duradouro',
        description: 'Busco um parceiro para construir algo especial. Compromisso, exclusividade e futuro juntos.',
        chips: ['Exclusividade', 'Compromisso', 'Futuro juntos'],
        emoji: '💍',
        accentColor: 'rose'
      },
      {
        id: 'casual_fixed',
        label: 'Caso Fixo',
        highlight: 'Recorrente, sem compromisso',
        description: 'Encontros regulares com a mesma pessoa. Conexão e prazer sem a pressão de um relacionamento formal.',
        chips: ['Encontros regulares', 'Mesma pessoa', 'Sem formalidades'],
        emoji: '💕',
        accentColor: 'pink'
      },
      {
        id: 'casual_flex',
        label: 'Encontros',
        highlight: 'Experiências pontuais',
        description: 'Momentos especiais quando a química acontece. Sem expectativas de continuidade, apenas o prazer do agora.',
        chips: ['Sem compromisso', 'Flexibilidade total', 'Experiências únicas'],
        emoji: '🍸',
        accentColor: 'amber'
      }
    ]
  },
  baby_other: {
    title: "O que você busca?",
    subtitle: "Escolha o tipo de conexão ideal para você",
    options: [
      {
        id: 'serious',
        label: 'Relacionamento Sério',
        highlight: 'Exclusivo e duradouro',
        description: 'Busco alguém para construir algo especial. Compromisso, exclusividade e futuro juntos.',
        chips: ['Exclusividade', 'Compromisso', 'Futuro juntos'],
        emoji: '💍',
        accentColor: 'rose'
      },
      {
        id: 'casual_fixed',
        label: 'Caso Fixo',
        highlight: 'Recorrente, sem compromisso',
        description: 'Encontros regulares com a mesma pessoa. Conexão e prazer sem a pressão de um relacionamento formal.',
        chips: ['Encontros regulares', 'Mesma pessoa', 'Sem formalidades'],
        emoji: '💕',
        accentColor: 'pink'
      },
      {
        id: 'casual_flex',
        label: 'Encontros',
        highlight: 'Experiências pontuais',
        description: 'Momentos especiais quando a química acontece. Sem expectativas de continuidade, apenas o prazer do agora.',
        chips: ['Sem compromisso', 'Flexibilidade total', 'Experiências únicas'],
        emoji: '🍸',
        accentColor: 'amber'
      }
    ]
  }
};

// Determine screen variant based on user profile
export function getScreenVariant(role: string | undefined, gender: string | undefined, orientation: string | undefined): ScreenVariant {
  const isSponsor = role === 'sponsor';
  const isFemale = gender === 'female';
  const isHeteroOrBi = orientation === 'straight' || orientation === 'bisexual';

  if (isSponsor) {
    // Sponsor (daddy) variants
    if (isHeteroOrBi) {
      return 'daddy_hetero';
    }
    return 'daddy_other';
  } else {
    // Sponsored (baby) variants
    if (isFemale && isHeteroOrBi) {
      return 'baby_female_hetero_bi';
    }
    return 'baby_other';
  }
}

// Get the screen configuration for current user
export function getRelationshipScreenConfig(role: string | undefined, gender: string | undefined, orientation: string | undefined): RelationshipScreenConfig {
  const variant = getScreenVariant(role, gender, orientation);
  return RELATIONSHIP_INTENT_SCREENS[variant];
}

// Legacy export for backward compatibility
export const RELATIONSHIP_OPTIONS = RELATIONSHIP_INTENT_SCREENS.daddy_hetero.options.map(opt => ({
  value: opt.id,
  title: opt.label,
  emoji: opt.emoji,
  subtitle: opt.highlight,
  description: opt.description,
  highlights: opt.chips,
  accentColor: opt.accentColor,
  testId: `relationship-option-${opt.id.replace('_', '-')}`
}));
